<template>
	<el-container class="pages-common pre-tax-index">
		<leftNav />
		<el-main class="main-body">
			<div class="page-header">
				<div class="title">扣款台账</div>
				<el-form :inline="true" :model="formInline" class="demo-form-inline" style="display: inline-block;">
					<el-form-item label="姓名">
						<el-input v-model="formInline.name" placeholder="请输入" clearable></el-input>
					</el-form-item>
					<el-form-item label="工号">
						<el-input v-model="formInline.empNo" placeholder="请输入" clearable></el-input>
					</el-form-item>
					<el-form-item label="身份证号">
						<el-input v-model="formInline.IDCord" placeholder="请输入" clearable></el-input>
					</el-form-item>
					<el-form-item label="扣款项目">
						<el-select clearable v-model="formInline.projectName" multiple :collapse-tags="true" >
							<el-option label="项目名称1" value="项目名称1"></el-option>
							<el-option label="项目名称2" value="项目名称2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="扣款出处">
						<el-select clearable v-model="formInline.source" multiple :collapse-tags="true" >
							<el-option label="工资" value="工资"></el-option>
							<el-option label="佣金" value="佣金"></el-option>
							<el-option label="合作费" value="合作费"></el-option>
							<el-option label="均可" value="均可"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="应扣月份">
						<el-select clearable v-model="formInline.month" multiple :collapse-tags="true" >
							<el-option label="11月" value="11月"></el-option>
							<el-option label="12月" value="12月"></el-option>
							<el-option label="01月" value="01月"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="实扣月份">
						<el-select clearable v-model="formInline.actualMonth" multiple :collapse-tags="true" >
							<el-option label="11月" value="11月"></el-option>
							<el-option label="12月" value="12月"></el-option>
							<el-option label="01月" value="01月"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="上期结余未扣金额是否为0">
						<el-select clearable v-model="formInline.balance" >
							<el-option label="是" :value="true"></el-option>
							<el-option label="否" :value="false"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" size="small" @click="onSubmit" >查询</el-button>
						<el-button type="warning" size="small" @click="onReset" >重置</el-button>
					</el-form-item>
				</el-form>
				<div>
					<!-- <el-upload class="upload-demo" :action="upfileUrl" :on-success='uploadSuccess' :on-error="uploadError" :file-list="fileList"
					 :show-file-list="false" accept=".xls,.xlsx">
						<el-button size="small" type="primary">导入实扣</el-button>
					</el-upload>
					<el-button size="small" type="success">下载实扣数据</el-button> -->
					<el-button size="small" type="info">导出记录</el-button>
				</div>
			</div>
			<div class="page-main">
				<el-table :data="tableData" border stripe size='small' >
					<el-table-column prop="value2" label="导入时间" width="140" align="center">
					</el-table-column>
					<el-table-column prop="value2" label="导入人员" width="100" align="center">
					</el-table-column>
					<el-table-column prop="value2" label="姓名" width="100" align="center">
					</el-table-column>
					<el-table-column prop="value2" label="工号" width="100" align="center">
					</el-table-column>
					<el-table-column prop="value2" label="部门" width="150" align="center">
					</el-table-column>
					<el-table-column prop="value2" label="身份证号码" width="160" align="center">
					</el-table-column>
					<el-table-column prop="value2" label="应扣月份" width="100" align="center">
					</el-table-column>
					<el-table-column prop="value2" label="扣款项目" width="180" align="center">
					</el-table-column>
					<el-table-column prop="value2" label="扣款出处" width="100" align="center">
					</el-table-column>
					<el-table-column prop="value2" label="应扣金额合计" width="100" align="center">
					</el-table-column>
					<el-table-column prop="value2" label="上期结余未扣金额" width="120" align="center">
					</el-table-column>
					<el-table-column prop="value2" label="累计应扣金额" width="110" align="center">
					</el-table-column>
					<el-table-column prop="value2" label="实扣月份" width="100" align="center">
					</el-table-column>
					<el-table-column prop="value2" label="本期工资实扣" width="100" align="center">
					</el-table-column>
					<el-table-column prop="value2" label="本期合作费实扣" width="110" align="center">
					</el-table-column>
					<el-table-column prop="value2" label="本期绩效实扣" width="100" align="center">
					</el-table-column>
					<el-table-column prop="value2" label="本期佣金实扣" width="100" align="center">
					</el-table-column>
					<el-table-column prop="value2" label="本期花红实扣" width="100" align="center">
					</el-table-column>
					<el-table-column prop="value2" label="本期实扣合计" width="100" align="center">
					</el-table-column>
					<el-table-column prop="value2" label="累计工资实扣" width="100" align="center">
					</el-table-column>
					<el-table-column prop="value2" label="累计合作费实扣" width="110" align="center">
					</el-table-column>
					<el-table-column prop="value2" label="累计绩效实扣" width="100" align="center">
					</el-table-column>
					<el-table-column prop="value2" label="累计佣金实扣" width="100" align="center">
					</el-table-column>
					<el-table-column prop="value2" label="累计花红实扣" width="100" align="center">
					</el-table-column>
					<el-table-column prop="value2" label="累计实扣合计" width="100" align="center">
					</el-table-column>
					<el-table-column prop="value2" label="累计未知金额" width="100" align="center">
					</el-table-column>
				</el-table>
			
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
				 :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
			
		</el-main>
	</el-container>
</template>

<script>
	import leftNav from '../components/nav.vue';
	import {
		indexPagers
	} from '../api/index'
	export default {
		components: {
			leftNav
		},
		data() {
			return {
				formInline:{},
				currentPage: 1,
				total: 40,
				pageSize:20,
				tableData:[],
				fileList:[],
				upfileUrl:''
			}
		},
		mounted() {
			
		},
		methods: {
			queryList(){
				let data = {
					name:this.formInline.name,
					empNo:this.formInline.empNo,
					idCord:this.formInline.IDCord,
					projectName:this.formInline.projectName,
					source:this.formInline.source,
					month:this.formInline.month,
					actualMonth:this.formInline.actualMonth,
					balance:this.formInline.balance,
					page:this.currentPage,
					pageSize:this.pageSize
				}
				indexPagers(data).then(res =>{
					console.log(res);
				}).catch(err =>{
					console.log(err);
				})
			},
			onSubmit() {
				console.log('onSubmit')
				console.log(this.formInline)
				// this.queryList();
			},
			onReset(){
				console.log('onReset');
				this.formInline = {};
				// this.queryList();
			},
			uploadSuccess(response, file, fileList) {
				console.log(response);
				console.log(file)
			},
			uploadError(err, file, fileList) {
				console.log(err);
				console.log(file)
			},
			handleSizeChange(val) {
				this.pageSize = val;
				this.currentPage = 1;
				this.queryList();
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.queryList();
				console.log(`当前页: ${val}`);
			},
		}
	}
</script>

<style>
</style>
